module.exports = __webpack_public_path__ + "static/media/Mokoto Glitch.17850ca8.ttf";